<script setup lang="ts">
import Select from '@mobile/components/Select/Select.vue'

import { Props } from './types'

withDefaults(defineProps<Props>(), {
  mode: 'single',
})

// models
const model = defineModel<InstanceType<typeof Select>['$props']['value']>()
</script>

<template>
  <div class="flex flex-col">
    <span class="pb-1 text-xs">{{ label }}</span>
    <Select
      v-model="model"
      label="name"
      :mode
      :options
      :clearable
      :searchable
      :customLabelSlot
      :trackBy
      :data-testid="dataTestId"
    />
  </div>
</template>
